module.exports = __webpack_public_path__ + "static/media/rejectResolution.b35c21e7.svg";